var map = {
	"./BOOST.svg": 2372,
	"./GRAB.svg": 2373,
	"./MBB.svg": 2374,
	"./TNG.svg": 2375,
	"./direpay.svg": 2376,
	"./doitnow.svg": 2377,
	"./duitnow.svg": 2378,
	"./fpay.svg": 2379,
	"./fpay2.svg": 2380,
	"./fpx.svg": 2381,
	"./online_banking.svg": 2382,
	"./rapidpays.svg": 2383,
	"./secret_pay.svg": 2384,
	"./secret_pay_offline.svg": 2385,
	"./secret_pay_pro.svg": 2386,
	"./secret_pay_pro_b.svg": 2387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;